'use strict';

var trackingUtils = require('../../modules/utils/tracking.utils');
var tripTypeUtils = require('../../modules/utils/trip_type');
var currentSearchSingletonModel = require('../../modules/models/current_search.singleton.model');

const DP_RESUME_CONTAINER = '.dp_flights_filtered';
const DP_SUMMARY_CONTAINER = '.flights_filters_summary_container_mobile';

var calculateLayoutStyles = function() {
    var tagsForFiltersOnTop = this.tagsForFiltersOnTop;
    var rowLayout = tagsForFiltersOnTop ? 'od-flights-filters-summary' : '';
    var verticalMargins = tagsForFiltersOnTop ? '' : 'odf-space-outer-top-m odf-space-outer-bottom-xs';
    var numMatchesClass = tagsForFiltersOnTop ? '' : 'od-filters-summary-matched-results';
    return {
        summaryContainer: rowLayout,
        numMatchesContainer: [numMatchesClass, verticalMargins].join(' '),
    };
};

var updateEnabled = function(model, tripType) {
    this.model.set('enabled', tripTypeUtils.isOneWayOrRoundTrip(tripType));
};

var MainView = Backbone.View.extend({
    events: {
        'tap .reset_filter': 'resetFilters',
    },
    initialize: function(options) {
        var currentSearchModel = currentSearchSingletonModel.getInstance();
        Odigeo._.assign(this, Odigeo._.pick(options, ['tagsForFiltersOnTop', 'keys', 'templates']));
        this.viewInjector = options.viewInjector(this);
        this.widgetId = options.widgetId;
        this.listenTo(currentSearchModel, 'change:type', Odigeo._.bind(updateEnabled, this));
        this.listenTo(this.model, 'change:enabled', this.toggleVisibilityOnScopeChange);
        this.listenTo(this.model.get('numResults'), 'change', this.toggleVisibilityOnResultsChange);
        updateEnabled.call(this, currentSearchModel, currentSearchModel.get('type'));
    },
    render: function() {
        this.$el.html(this.templates.filtersSummaryContainer({
            layout: calculateLayoutStyles.call(this),
            keys: this.keys,
        }));
        this.viewInjector.create('matchedResults');
        this.viewInjector.create('tags');
        return this;
    },
    toggleVisibilityOnScopeChange: function(model, enabled) {
        this.$el.toggleClass('odf-hidden', !enabled);
    },
    toggleVisibilityOnResultsChange: function(numResults) {
        var matched = numResults.get('matched').getNumber();
        var visible = matched === 0 || matched < numResults.get('total').getNumber();
        if (this.model.get('enabled')) {
            this.$el.toggleClass('odf-hidden', !visible);
        }
    },
    resetFilters: function() {
        trackingUtils.trackEvent('results_filters', 'undo_filtering_results');
        Odigeo.trigger(this.widgetId + ':resetFiltersClicked');
    },
    dpResumeNumResults: function(numFilteredResults, numResults, isFiltering) {
        if (isFiltering) {
            this.$el.find(DP_RESUME_CONTAINER).html(this.templates.flightsNumFiltered({
                flightsFiltered: Odigeo.Utils.pluralizeAll(this.keys.flightsLeftText, numFilteredResults, numResults),
            }));
        }
        this.$el.find(DP_SUMMARY_CONTAINER).toggleClass('odf-hidden', !isFiltering);
    },
});

module.exports = MainView;
